module.exports = __webpack_public_path__ + "img/sld_ch_6_t1_green.11ebf0e2.svg";